const data = [];

data.push({
    name: "问题反馈",
    class: "el-icon-document-add",
    path: "/TourOpinion",
});

data.push({
    name: "部门管理",
    class: "el-icon-tickets",
    path: "/DeptManage",    
});

data.push({
    name: "类型管理",
    class: "el-icon-reading",
    path: "/TypeManage",
});

data.push({
    name:"前端用户",
    class:"el-icon-notebook-1",
    path:"/TourInfo"
})


data.push({
    name: "用户管理",
    class: "el-icon-user",
    children: [{
        name: "后端用户",
        path: "/UserInfo",
    }, {
        name: "部门配置",
        path: "/UserDept",
    }, {
        name: "角色配置",
        path: "/UserRole",
    }, {
        name: "页面权限",
        path: "/UserPage",
    }]
});

data.push({
    name: "系统配置",
    class: "el-icon-setting",
    children: [
        {
            name: "通知公告",
            path: "/BasicNotice",
        }, {
            name: "文件共享",
            path: "/BasicShare",
        }, {
            name: "单选配置",
            path: "/BasicType1",
        }, {
            name: "多选配置",
            path: "/BasicType2",
        }, {
            name: "参数设置",
            path: "/BasicParam",
        }
    ]
});

data.push({
    name: "日志审计",
    class: "el-icon-tickets",
    children: [{
        name: "用户登录",
        path: "/LogLogin",
    }, {
        name: "用户操作",
        path: "/LogOperate",
    }, {
        name: "上传文件",
        path: "/LogUpload",
    }, {
        name: "下载文件",
        path: "/LogDownLoad",
    }, {
        name: "传输日志",
        path: "/LogJson",
    }, {
        name: "应用日志",
        path: "/LogApp",
    }, {
        name: "服务监控",
        path: "/LogServer",
    }, {
        name: "服务异常",
        path: "/LogException",
    }
    ]
});

export default data;